import { useEffect, useMemo, useState } from 'react'
import { cachedGet } from './api.js'

// The four reference lists every Lab surface needs, fetched once per session
// (cachedGet dedupes across pages). Both /lab and /patient/:id/lab need all four:
// StagePicker needs `stages`, LabDetailDrawer needs `branchName` or สาขา renders
// as "#3", and stageById/vendorMap are inputs to the optimistic row patches in
// lib/labWrites.js.
//
// Each fetch fails independently and silently — a missing branch list must not
// take the page down with it, it just degrades one label.
const asList = (r) => (Array.isArray(r) ? r : (r?.items || []))

export default function useLabRefs() {
  const [stages, setStages] = useState([])
  const [vendors, setVendors] = useState([])
  const [doctors, setDoctors] = useState([])
  const [branchName, setBranchName] = useState({})

  useEffect(() => {
    cachedGet('/api/labstage')
      .then((r) => setStages(asList(r).slice().sort((a, b) => Number(a.id) - Number(b.id)))).catch(() => {})
    cachedGet('/api/lab/lablist')
      .then((r) => setVendors(asList(r))).catch(() => {})
    cachedGet('/api/branches')
      .then((br) => setBranchName(Object.fromEntries(asList(br).map((b) => [String(b.id ?? b.branch_id), b.name || b.branch_name || `สาขา #${b.id}`])))).catch(() => {})
    cachedGet('/api/doctors').then((r) => setDoctors(asList(r))).catch(() => {})
  }, [])

  const stageById = useMemo(() => Object.fromEntries(stages.map((s) => [Number(s.id), s])), [stages])
  const vendorMap = useMemo(() => new Map(vendors.map((v) => [Number(v.id), v])), [vendors])

  return { stages, vendors, doctors, branchName, stageById, vendorMap }
}
